import dates from "@/services/date";

export default {
  data: function() {
    return {
      requiresEmailValidation: null,
      lastValidationSentAt: '2020-06-30T13:20:27+01:00',
      timeLeftTillCanSendValidation: null,
      validationSuccess: false
    }
  },
  methods: {
    onSendToken() {
      if (this.lastValidationSentAt === null || dates.pastDateTime(dates.addTime(dates.parseISOString(this.lastValidationSentAt), {minutes: 30}))) {
        if (this.$refs.homeMessages) {
          this.$refs.homeMessages.toggleValidationSuccess(false);
        } else {
          this.validationSuccess = false;
        }
        this.$api.verification.sendValidationEmail().then(() => {
          if (this.$refs.homeMessages) {
            this.$refs.homeMessages.toggleValidationSuccess(true);
          } else {
            this.validationSuccess = true;
          }
          this.lastValidationSentAt = dates.isoString();
        });
      } else {
        this.timeLeftTillCanSendValidation = dates.timeToNow(dates.addTime(dates.parseISOString(this.lastValidationSentAt), {minutes: 30}));
      }
    },
  }
}
